import { useEffect } from 'react';

import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
export default function FrontendObservability() {
  useEffect(() => {
    const faroUrl = process.env.NEXT_PUBLIC_FARO_URL;
    const faroAppName = process.env.NEXT_PUBLIC_FARO_APP_NAME;
    const APP_ENV = process.env.APP_ENV;
    const APP_NAME = process.env.APP_NAME;
    const COMMIT_ID = process.env.COMMIT_ID;

    if (!faroUrl || !['production', 'staging'].includes(APP_ENV)) return;

    try {
      initializeFaro({
        url: faroUrl,
        app: {
          name: faroAppName || APP_NAME || 'auth-front',
          version: COMMIT_ID || '1.0.0',
          environment: APP_ENV
        },
        instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()]
      });
    } catch (e) {
      console.error('[FrontendObservability] Faro init failed', e);
    }
  }, []);

  return null;
}
